import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class ReembolsosService
{
    constructor(public http: HttpClient, ) { }

    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeArchivos(idPostulacion: any)
    {
        return this.http.get(`${environment.urlBase}/postulaciones/${idPostulacion}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }
    obtieneProductos() 
    { 
        return this.http.get(`${environment.urlBase}/productos`, 
               { headers: this.armaCabecera() } ).toPromise(); 
    }

    traeCategorias(idTipo: any)
    {
        return this.http.get(`${environment.urlBase}/reembolsos/categorias/tipos/${idTipo}`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeSubCategorias(idCategoria: any)
    {
        return this.http.get(`${environment.urlBase}/reembolsos/categorias/${idCategoria}`,
               { headers: this.armaCabecera() }).toPromise();
    }

    obtieneMontoReembolso(subcategoria: any,tipodocumento:any,monto: any)
    {  
        return this.http.get(`${environment.urlApiOperacion}/reembolso/${subcategoria}/tipodocumento/${tipodocumento}/monto/${monto}`,
        { headers:this.armaCabecera() } ).toPromise()

    }
    traeMontoDisponibleSubCategoria(idPostulante: any, titular: boolean, idSubcategoria: any,idPostulacion:any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/usuario/${idPostulante}/titular/${titular}/reembolsos/subcategoria/${idSubcategoria}/idPostulacion/${idPostulacion}`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traePrevisionesDisponibles()
    {
        return this.http.get(`${environment.urlBase}/previsiones`, { headers: this.armaCabecera() }).toPromise();
    }

    ingresaReembolso(reembolso: any, idUsuario:any, idCarga:any, nombreUsuario: any, subcategoria: any, idUsuarioSesion:any)
    {

        let fechaDocumento = reembolso.fechaDocumento.split('-')[2] + '-' + reembolso.fechaDocumento.split('-')[1] + '-' +
                             reembolso.fechaDocumento.split('-')[0]

        return this.http.post(`${environment.urlBase}/postulaciones/reembolso`,
        {
            idUsuario: idUsuario,
            idCarga: idCarga,
            idUsuarioSesion:idUsuarioSesion,
            idProducto: 3,
            reembolso: {
                rutPrestador: reembolso.rutPrestador.split('-')[0],
                dvPrestador: reembolso.rutPrestador.split('-')[1],
                tipoDocumento: reembolso.tipoDocumento,
                numDocumento: reembolso.nDocumento,
                numBoleta: reembolso.nBoleta,                
                montoCopago: reembolso.montoCopago,
                montoReembolso: reembolso.montoReembolso,
                fechaDocumento: fechaDocumento,
                idTipo: reembolso.tipoReembolso,
                idReembolsoCat: reembolso.categoriaPrestacion,
                idReembolsoSubcat: subcategoria.id,
                idPrevision: reembolso.prevision
            },
            archivoAdjunto: reembolso.archivos,
            notificacion: { email: reembolso.email, nombreCompleto: nombreUsuario, nombreProducto:'REEMBOLSO' }
        },
        { headers: this.armaCabecera() }).toPromise();
    }
 
    retornarCapacidadDescuento(idUsuario: any, idCarga: any, titular: boolean, subCategoriaPrestacion: any)
    {
        return this.http.post(`${environment.urlApiSolicitudes}/capacidad/descuento`,
            {
                idUsuario: idUsuario,
                idCarga: idCarga,
                titular:titular,
                idSubcategoria:subCategoriaPrestacion
             },
            { headers: this.armaCabecera() }).toPromise();
    }

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
